import AgcCheckReducer from "../reducers/AgcCheckReducer";
import BaseAction from "./BaseAction";

class AgcCheckAction extends BaseAction {}

const action = new AgcCheckAction(AgcCheckReducer);

export default action;
